import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { useSession } from "../../authentications/SessionContext";
import { SIDEBAR_OPTIONS_LIST } from "../../utilities/constants";
import SidebarComponent from "./SidebarComponent";
import { primaryColor } from "../../utilities/colors";
import { getFilter } from "../../utilities/get-filter";
const SidebarList = styled.div`
  width: 100%;
  height: 60px;
  justify-content: flex-start;
  align-items: center;

  font-family: "Comfortaa", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #8a94a6;
  margin-bottom: 10px;
  text-decoration: none;
  padding: 6px;

  &:hover {
    background-color: ${(props) => props["data-background"] || "#ffefeb"};
    color: ${(props) => props["data-color"] || "#f2994a"};
    border-radius: 10px;
    width: 95%;
    cursor: pointer;
    img {
      filter: ${(props) =>
        props["data-isvtex"] ? getFilter("#BAF76A") : getFilter("#f2994a")};
    }
  }
  &:focus {
    background-color: ${(props) => props["data-background"] || "#ffefeb"};
    color: ${(props) => props["data-color"] || "#f2994a"};
    border-radius: 10px;
    width: 95%;
    cursor: pointer;
    img {
      filter: ${(props) =>
        props["data-isvtex"] ? getFilter("#BAF76A") : getFilter("#f2994a")};
    }
  }

  &.active {
    background-color: ${(props) => props["data-background"] || "#ffefeb"};
    color: ${(props) => props["data-color"] || "#f2994a"};
    border-radius: 10px;
    padding: 6px;
    width: 95%;
    img {
      filter: ${(props) =>
        props["data-isvtex"] ? getFilter("#BAF76A") : getFilter("#f2994a")};
    }
  }
`;
const SidebarText = styled.span`
  display: "block";
  margin-left: 8px;
  width: 170px;
`;
function SidebarListOption({
  sideBarOption,
  index,
  handleClick,
  showSidebar,
  nestingLevel,
}) {
  const { sessionInfo } = useSession();
  const { isVTEX, is_vtex_admin, is_vtex_omantal } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [isChildMenuOpen, setIsChildMenuOpen] = useState(false);
  // console.log(
  //   "isVTEX, is_vtex_admin, is_vtex_omantal",
  //   isVTEX,
  //   is_vtex_admin,
  //   is_vtex_omantal
  // );
  return (
    <>
      <SidebarList
        key={index}
        data-isvtex={isVTEX}
        data-color={isVTEX ? primaryColor.primary : "#ff5837"}
        data-background={isVTEX ? "#000000" : "#ffefeb"}
        className={[
          sideBarOption?.link === window?.location?.pathname && "active",

          !sideBarOption?.isAdmin && !sideBarOption?.isVtexOption && "d-flex",

          sideBarOption?.isVtexOption &&
            isVTEX &&
            !sideBarOption?.isAdmin &&
            "d-flex",

          sideBarOption?.isAdmin && isVTEX && is_vtex_admin && "d-flex",

          // Hide if isVtexOption is true and isVTEX is false
          sideBarOption?.isVtexOption && !isVTEX && "d-none",

          // Hide if isAdmin is true and the user is not an admin
          sideBarOption?.isAdmin && isVTEX && !is_vtex_admin && "d-none",
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={() => {
          if (sideBarOption.children) {
            setIsChildMenuOpen(!isChildMenuOpen);
            return;
          }
          return handleClick(sideBarOption);
        }}
      >
        {sideBarOption.icon !== "" && (
          <img
            src={sideBarOption.icon}
            alt="dashboard-Icon"
            height="24px"
            width="24px"
          />
        )}
        {showSidebar ? (
          <SidebarText style={{ paddingLeft: `${nestingLevel * 1.5}rem` }}>
            {t[sideBarOption.name]}
          </SidebarText>
        ) : (
          ""
        )}

        {sideBarOption.children ? (
          isChildMenuOpen ? (
            <i className="bi bi-chevron-down"></i>
          ) : (
            <i className="bi bi-chevron-right"></i>
          )
        ) : (
          ""
        )}
      </SidebarList>

      {sideBarOption.children && isChildMenuOpen && (
        <SidebarComponent
          optionsList={sideBarOption.children}
          nestingLevel={nestingLevel + 1}
        />
      )}
    </>
  );
}

export default SidebarListOption;
